export default __webpack_public_path__ + "static/media/pos.f70115dc.svg";